import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";

import { i18n } from "../../translate/i18n";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const FlowBuilderAddTextModal = ({ open, onSave, onUpdate, data, close }) => {
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [textDig, setTextDig] = useState();

  useEffect(() => {
    if (open === "edit") {
      setTextDig(data.data.label);
      setActiveModal(true);
    } else if (open === "create") {
      setTextDig("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { label: textDig },
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({
        text: textDig,
      });
    }
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={560}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.text.editTitle" : "aeros.flow.modals.text.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-text-message">
          {i18n.t("aeros.flow.modals.text.message")}
        </label>
        <TextField
          id="flow-text-message"
          className={m.input}
          variant="outlined"
          multiline
          rows={6}
          name="text"
          autoFocus
          value={textDig || ""}
          placeholder={i18n.t("aeros.flow.content.textPlaceholder")}
          onChange={(e) => setTextDig(e.target.value)}
        />
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderAddTextModal;
